module.exports = __webpack_public_path__ + "static/media/2 (11).f66ba212.jpg";